<script>
import { CONVERSATION_DIRECTION } from '../../constants';

const CONVERSATION_DIRECTION_LABELS = {
  all: 'Todas',
  incoming: 'Receptivas',
  outgoing: 'Ativas',
};

export default {
  name: 'ReportFiltersConversationDirection',
  emits: ['conversationDirectionFilterSelection'],
  data() {
    const translatedOptions = Object.values(CONVERSATION_DIRECTION).map(
      option => ({
        ...option,
        name:
          CONVERSATION_DIRECTION_LABELS[option.id] ||
          this.$t(option.translationKey),
      })
    );

    return {
      // relies on translations, need to move it to constants
      selectedOption: translatedOptions[0],
      options: translatedOptions,
    };
  },
  methods: {
    updateRange(selectedRange) {
      this.selectedOption = selectedRange;
      this.$emit('conversationDirectionFilterSelection', selectedRange);
    },
  },
};
</script>

<template>
  <div class="multiselect-wrap--small">
    <multiselect
      v-model="selectedOption"
      class="no-margin"
      track-by="name"
      label="name"
      :placeholder="$t('FORMS.MULTISELECT.SELECT_ONE')"
      selected-label
      :select-label="$t('FORMS.MULTISELECT.ENTER_TO_SELECT')"
      deselect-label=""
      :options="options"
      :searchable="false"
      :allow-empty="false"
      @select="updateRange"
    />
  </div>
</template>
